export interface Zone {
  id: string;
  name: string;
  roomId: string; // maps to ROOM_SPECIES in encounter.ts
  description: string;
  encounterChance?: number; // overrides default 0.08 if set
}

// Zone definitions — each maps to a room species pool
export const ZONES: Zone[] = [
  {
    id: "sales_floor",
    name: "Sales Floor",
    roomId: "sales_floor",
    description: "Open office rows with motivational posters. Salespup and Closer lurk here.",
  },
  {
    id: "dev_dungeon",
    name: "Dev Dungeon",
    roomId: "dev_dungeon",
    description: "Dark corridors lit by monitor glow. Debugcat and Deploydog patrol.",
    encounterChance: 0.1, // denser encounters in the dungeon
  },
  {
    id: "finance_hub",
    name: "Finance Hub",
    roomId: "finance_hub",
    description: "Spreadsheet-covered desks and coffee machines. Auditbear roams.",
    encounterChance: 0.06,
  },
  {
    id: "creative_lab",
    name: "Creative Lab",
    roomId: "creative_lab",
    description: "Colorful walls and bean bags. Designfox and Brandbird flutter.",
  },
  {
    id: "ops_center",
    name: "Ops Center",
    roomId: "ops_center",
    description: "Server racks and Gantt charts. Opsbot and Scrumlord defend.",
    encounterChance: 0.12, // high-encounter zone
  },
  {
    id: "hr_office",
    name: "HR Office",
    roomId: "hr_office",
    description: "Onboarding binders and culture posters. Recruitling and Hiremaster greet newcomers.",
  },
  {
    id: "wild_grass",
    name: "Wild Grass",
    roomId: "default",
    description: "Unclaimed territory between departments. Starter-type Surggies wander.",
  },
];

export function getZoneById(id: string): Zone | undefined {
  return ZONES.find((z) => z.id === id);
}

export function getZoneByRoomId(roomId: string): Zone | undefined {
  return ZONES.find((z) => z.roomId === roomId);
}
